import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'

interface QuestionInput {
  optionCount?: number
  title: string
  description?: string
  optionValues?: number[]
}
export interface HorizontalQuestionInput extends QuestionInput {
  type: 'normal' | 'mbti'
  leftQuestion?: string
  rightQuestion?: string
}

export interface VerticalQuestionInput extends QuestionInput {
  questions: string[]
}

@Component({
  template: '',
})
export abstract class MbtiQuestion implements OnChanges {
  @Input() abstract question: QuestionInput | undefined
  @Output() selected: EventEmitter<number> = new EventEmitter<number>()

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('question') && changes.question.currentValue !== undefined) {
      this.onQuestionChanged()
    }
  }

  protected abstract onQuestionChanged(): void
}

@Component({
  template: '',
})
export abstract class HorizontalQuestion extends MbtiQuestion {
  @Input() abstract question: HorizontalQuestionInput | undefined
  options: Array<number> = []

  protected onQuestionChanged(): void {
    if (this.question !== undefined) {
      this.options = new Array(this.question.optionCount)
    }
  }
}

@Component({
  template: '',
})
export abstract class VerticalQuestion extends MbtiQuestion {
  @Input() abstract question: VerticalQuestionInput | undefined

  protected onQuestionChanged(): void {}
}
